/** Enum pour lister les différentes parties communes aux routes. */
export enum ERouteUrlPart {

	new = "new",
	edit = "edit"
}